import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-no-results',
  templateUrl: './no-results.component.html',
  styleUrls: ['./no-results.component.scss'],
})
export class NoResultsComponent {
  @Input() addStr = 'Add new';
  @Input() noDataStr;
  @Input() canEdit: boolean;
  @Output() addFirst = new EventEmitter<void>();
}
